import { AgentState, AgentSelection, OfficeSelection, SubtreeStateMap, AgentSearchState } from "app/pages/DiscountEditor/modules/Agent/state";
import { AgentSearchResult, AgentOffice } from "app/shared/model/Agent";
import { AgentsFilterDto, AgentInAgentsFilterDto } from "app/shared/model/DiscountDto";
import { AgentSelectionMode } from "app/shared/model/AgentSelectionMode";

function getRoot(state: any) : AgentState {
    return state.agentSelection;
}

export function getSearchTerm(state: string) {
    return getRoot(state).search.searchTerm;
}

 export function getAgentSearchState(state: any) : AgentSearchState {
    return getRoot(state).search.searchState;
 }

export function getSearchResults(state: any) : AgentSearchResult[] {
    return getRoot(state).search.results;
}

export function isAgentSelected(state: any, id: string) : boolean | undefined { 
    const selectionRec = getRoot(state).agents[id];
    if (!selectionRec)
        return false;
    if (selectionRec.isIndeterminate)
        return undefined;
    return selectionRec.isChecked;
}

export function getAgentSelections(state: any) : AgentSelection[] { 
    const selectionMap = getRoot(state).agents;
    return Object.keys(selectionMap)
        .map(k => selectionMap[k] as AgentSelection)
    ;
}

export function getAgentOfficeVisibilityMap(state: any) : SubtreeStateMap {
    return getRoot(state).treeState;
}

export function getAgentOffices(state: any, agentId: string) : OfficeSelection[]|undefined {
    const offices = getRoot(state).offices;
    const ids =  offices.byAgent[agentId];
    if (!ids)
        return undefined;

    return ids.map(id => offices.idMap[id]);
}

export function getAgentSelectionMode(state: any): AgentSelectionMode {
    return getRoot(state).selectionMode;
}


function getSelectedOfficesByAgent(agentState: AgentState, agentId: string) {
    const offices = agentState.offices.byAgent[agentId];
    if (!offices)
        return [];

    return offices.filter(o => agentState.offices.idMap[o].isSelected);
}

export function getAgentFilterDto(state: any) : AgentsFilterDto {
    const root = getRoot(state);
    
    const selectionMode = root.selectionMode !== undefined 
        ? root.selectionMode 
        : AgentSelectionMode.AllAgents;
    
    if (selectionMode === AgentSelectionMode.AllAgents) {
        return {
            selectionMode: AgentSelectionMode.AllAgents,
            agents: []
        };
    }

    let agentFilters : AgentInAgentsFilterDto[] = [];
    Object.keys(root.agents).forEach(a => {
        if (a === undefined)
            return;

        const rec = root.agents[a];
        if (rec === undefined || (!rec.isChecked && !rec.isIndeterminate))
            return;

        const agentId = rec.agent.id;

        let toAdd : AgentInAgentsFilterDto = {
            agentId: agentId,
            allOffices: rec.isChecked,
            offices: rec.isIndeterminate 
                ? (getSelectedOfficesByAgent(root, agentId))
                : []
        };

        agentFilters.push(toAdd);
    })

    return {
        selectionMode: selectionMode,
        agents: agentFilters
    };
}